import React, { useEffect, useState } from 'react';

import {
  BACKDATED_LIST_VISIBLE,
  backdatedLineCopy,
  backdatedRowCopy,
} from './backdatedCompletions';

/**
 * bk-1865 — "+N backdated discharges completed today" line with an inline
 * list (click toggles; Esc closes). Renders nothing at N = 0. Pure view over
 * the items already delivered by the dashboard / discharges fetch.
 */
export default function BackdatedCompletionsLine({ items, testId = 'backdated-completions' }) {
  const [open, setOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const n = items.length;

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  if (n < 1) return null;
  const visible = showAll ? items : items.slice(0, BACKDATED_LIST_VISIBLE);
  const hidden = n - visible.length;

  return (
    <div className="text-[12px]" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="font-medium text-amber-700 dark:text-amber-400 hover:underline"
        data-testid={`${testId}-line`}
      >
        {backdatedLineCopy(n)}
      </button>
      {open && (
        <ul className="mt-1 space-y-1 max-h-60 overflow-y-auto text-slate-700 dark:text-slate-200" data-testid={`${testId}-list`}>
          {visible.map((it) => (
            <li key={it.admission_id} data-testid={`${testId}-row-${it.admission_id}`}>{backdatedRowCopy(it)}</li>
          ))}
          {hidden > 0 && (
            <li>
              <button
                type="button"
                onClick={() => setShowAll(true)}
                className="text-teal-700 dark:text-teal-300 hover:underline"
                data-testid={`${testId}-more`}
              >
                Show {hidden} more
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
